import type { Currencies } from 'src/types/common/Currencies';
import type { AddonsSlice } from 'src/inbox/ducks/paymentAddons';
import { ImmutableBoats, ImmutableSearchBoatDetails } from '../../types/boat/BoatDetail';
import { ImmutableOffer } from '../../types/offer/Offer';
import { ReduxState } from '../../types/reduxState';
import type { ImmutableTrip } from '../../types/trips/Trips';
import { ImmutableUser } from '../../types/user/User';

export const getCurrencies = ({ currencies }: ReduxState): Currencies => currencies;

export const getBoat = ({ boat }: ReduxState): ImmutableSearchBoatDetails => boat;

export const getPaymentAddons = ({ paymentAddons }: ReduxState): AddonsSlice => paymentAddons;

export const getUserBoats = ({ user }: ReduxState): ImmutableBoats => user.get('boats');

export const getOffer = ({ offer }: ReduxState): ImmutableOffer => offer;

export const getUser = ({ user }: ReduxState): ImmutableUser => user;

export const getCountryCode = ({ countryCode }: ReduxState): string => countryCode;

export const getLoading = ({ loading }: ReduxState) => loading;

export const getTransaction = ({ transaction }: ReduxState) => transaction;

export const getTrip = (tripId: string) => ({ trips }: ReduxState): ImmutableTrip => (
  trips.get('results').find((t) => t?.get('pk') === Number(tripId))
);

export const getTrips = ({ trips }: ReduxState) => trips;

export const getOccasions = ({ occasions }: ReduxState) => occasions;

export const isPaymentMethodSet = ({ user }: ReduxState) => (
  !!(user.get('is_owner') && user.get('has_payout_method'))
);

export const getLinkedCaptains = ({ linkedCaptains }: ReduxState) => linkedCaptains;

export const getMobileNativeWebView = ({ mobileNativeWebView }: ReduxState) => mobileNativeWebView;
